import { Phone } from "lucide-react";
import { Logo } from "../components/Logo";
import { TEL_LINK, PHONE_DISPLAY } from "../lib/site";
import { useLang } from "../lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
  <footer data-testid="footer-section" className="border-t border-white/10 bg-[#181510] pb-28 pt-14 md:pb-14">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-6 md:flex-row md:items-center md:px-12 lg:px-20">
      <div>
        <Logo />
        <p className="mt-3 font-mono text-xs uppercase tracking-[0.3em] text-white" data-testid="footer-slogan">
          Beyond The Ordinary
        </p>
      </div>
      <div className="flex flex-col items-start gap-3 md:items-end">
        <a
          href={TEL_LINK}
          className="flex items-center gap-2 font-archivo text-sm font-bold text-white transition-colors duration-300 hover:text-amber"
          data-testid="footer-phone-link"
        >
          <Phone size={15} className="text-amber" />
          {PHONE_DISPLAY}
        </a>
        <p className="text-xs text-white" data-testid="footer-copyright">
          © 2026 4thscenery. {t.rights}
        </p>
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-white" data-testid="footer-kvk">
          KVK 95131108
        </p>
        <a href="/login" className="font-mono text-[11px] uppercase tracking-[0.2em] text-white transition-colors hover:text-amber" data-testid="footer-admin-link">
          Beheer
        </a>
        <a href="/privacy" className="font-mono text-[11px] uppercase tracking-[0.2em] text-white transition-colors hover:text-amber" data-testid="footer-privacy-link">
          Privacyverklaring
        </a>
        <a href="/terms" className="font-mono text-[11px] uppercase tracking-[0.2em] text-white transition-colors hover:text-amber" data-testid="footer-terms-link">
          {t.footerTerms}
        </a>
      </div>
    </div>
  </footer>
  );
};
